// extracted by css-extract-rspack-plugin
export default {"narrowPaddingBottom":"PlaygroundHeader-module__narrowPaddingBottom__FZygX","narrowCompactPadding":"PlaygroundHeader-module__narrowCompactPadding__Sli5F"};